import { render, staticRenderFns } from "./area_index.vue?vue&type=template&id=2ed5f526"
import script from "./area_index.vue?vue&type=script&lang=js"
export * from "./area_index.vue?vue&type=script&lang=js"
import style0 from "./area_index.vue?vue&type=style&index=0&id=2ed5f526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports